
const FactoryIcon = () => {
    return (
        <svg width="44" height="33" viewBox="0 0 44 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.23926 15.3665L27.0747 8.70569C27.5927 8.48366 28.1478 8.85371 28.1478 9.40878V14.2934C28.1478 14.8485 28.7399 15.2185 29.2209 14.9965L42.8017 8.74269C43.3197 8.52066 43.8748 8.89071 43.8748 9.44578V29.1323C43.8748 31.0935 42.2836 32.6847 40.3223 32.6847H8.23926V15.3665Z" fill="#7C6FF5" />
            <path d="M23.4116 25.9128H19.9331C19.4521 25.9128 19.082 25.5428 19.082 25.0617V22.3974C19.082 21.9163 19.4521 21.5463 19.9331 21.5463H23.4116C23.8926 21.5463 24.2627 21.9163 24.2627 22.3974V25.0617C24.2627 25.5428 23.8926 25.9128 23.4116 25.9128Z" fill="#EEECFF" />
            <path d="M33.5503 25.9128H30.0718C29.5908 25.9128 29.2207 25.5428 29.2207 25.0617V22.3974C29.2207 21.9163 29.5908 21.5463 30.0718 21.5463H33.5503C34.0313 21.5463 34.4014 21.9163 34.4014 22.3974V25.0617C34.4014 25.5428 33.9943 25.9128 33.5503 25.9128Z" fill="#EEECFF" />
            <path d="M2.50375 1.45276L0.135449 29.2433C-0.0125696 31.0935 1.43061 32.6847 3.28085 32.6847H10.2747L7.75842 1.45276C7.72141 0.860682 7.20335 0.416626 6.64828 0.416626H3.6509C3.05882 0.416626 2.57776 0.860682 2.50375 1.45276Z" fill="#B8B0FF" />
        </svg>

    )
}

export default FactoryIcon;

